import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-neutral900 text-neutral50 dark:bg-neutral100 dark:text-neutral900",
        secondary:
          "border-transparent bg-neutral200 text-neutral900 dark:bg-neutral800 dark:text-neutral100",
        destructive:
          "border-transparent bg-error500 text-neutral50 dark:bg-error700 dark:text-neutral50",
        outline:
          "text-neutral700 dark:text-neutral300 border-neutral300 dark:border-neutral700",
        success:
          "border-transparent bg-success500 text-neutral50",
        warning:
          "border-transparent bg-warning500 text-neutral900",
        primary:
          "border-transparent bg-sumoPrimary text-sumoNavy",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
